import { Action } from '@ngrx/store';

export const SELECT = '[Division SubGroup] Select Division Sub Group';

export const GET_ASSET_COUNT = '[Division SubGroup] Get Asset Count';
export const GET_ASSET_COUNT_COMPLETE = '[Division SubGroup] Get Asset Count Complete';
export const GET_ASSET_COUNT_FAILED = '[Division SubGroup] Get Asset Count Failed';

export class SelectDivisionSubGroupAction implements Action {
    readonly type = SELECT;

    constructor(public payload: number) { }
}

export class GetAssetCountAction implements Action {
    readonly type = GET_ASSET_COUNT;

    constructor(public payload: { divisionId: number, subgroupId: number }) { }
}

export class GetAssetCountCompleteAction implements Action {
    readonly type = GET_ASSET_COUNT_COMPLETE;

    constructor(public payload: number) { }
}

export class GetAssetCountFailedAction implements Action {
    readonly type = GET_ASSET_COUNT_FAILED;

    constructor(public payload: any) { }
}

export type Actions
    = SelectDivisionSubGroupAction
    | GetAssetCountAction
    | GetAssetCountCompleteAction
    | GetAssetCountFailedAction;

